const ROUTE_RULES = [
  { pattern: /^\/mermas\/new(?:\/|$)/, suffix: '/mermas/new', permission: 'inventory.merma.create' },
  { pattern: /^\/purchases\/new(?:\/|$)/, suffix: '/purchases/new', permission: 'sales.create' },
  { pattern: /^\/purchases(?:\/|$)/, suffix: '/purchases', permission: 'sales.read' },
  { pattern: /^\/quotations\/new(?:\/|$)/, suffix: '/quotations/new', permission: 'quotation.create' },
  { pattern: /^\/quotations(?:\/|$)/, suffix: '/quotations', permission: 'quotation.read' },
  { pattern: /^\/purchase-orders(?:\/|$)/, suffix: '/purchase-orders', permission: 'purchase_order.read' },
  { pattern: /^\/delivery-guides(?:\/|$)/, suffix: '/delivery-guides', permission: 'delivery_guide.read' },
  { pattern: /^\/stock-requests(?:\/|$)/, suffix: '/stock-requests', permission: 'stock.read' },
  { pattern: /^\/providers(?:\/|$)/, suffix: '/providers', permission: 'provider.read' },
  { pattern: /^\/reports\/finances(?:\/|$)/, suffix: '/reports/finances', permission: 'sales.read' },
  { pattern: /^\/reports\/sales(?:\/|$)/, suffix: '/reports/sales', permission: 'sales.read' },
  { pattern: /^\/reports\/receivables(?:\/|$)/, suffix: '/reports/receivables', permission: 'client.read' },
  { pattern: /^\/reports(?:\/|$)/, suffix: '/reports', permission: 'stock.read' },
  { pattern: /^\/inventory(?:\/|$)/, suffix: '/inventory', permission: 'stock.read' },
  { pattern: /^\/stock(?:\/|$)/, suffix: '/stock', permission: 'stock.read' },
  { pattern: /^\/price-list(?:\/|$)/, suffix: '/price-list', permission: 'price.read' },
  { pattern: /^\/expenses(?:\/|$)/, suffix: '/expenses', permission: 'branch_expense.read' },
  { pattern: /^\/cash-register-logs(?:\/|$)/, suffix: '/cash-register-logs', permission: 'cash_register.logs.read' },
  { pattern: /^\/catalog(?:\/|$)/, suffix: '/catalog', permission: null },
];

export const getEquivalentBranchDestination = (pathname) => {
  const match = String(pathname || '').match(/^\/branches\/[^/]+(\/.*)?$/);
  if (!match) return null;
  const currentSuffix = match[1] || '';
  const rule = ROUTE_RULES.find((entry) => entry.pattern.test(currentSuffix));
  return rule ? { suffix: rule.suffix, permission: rule.permission } : null;
};

export const buildEquivalentBranchPath = (branchId, destination) => {
  if (!branchId || !destination?.suffix) return '/home';
  return `/branches/${branchId}${destination.suffix}`;
};
